var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../atoms/BaseButton';
import styled from 'styled-components';
import Dialog from '../atoms/Dialog';
import { useNavigate } from 'react-router-dom';
import { useRequest } from '../../hooks/requestHook';
import { useNotify } from '../../hooks/notificationHook';
import { Alert, Box, Table, TableBody, TableCell, TableHead, TableRow, Typography, Checkbox, FormControlLabel, } from '@mui/material';
import { sampleOrder as sampleOrderApi } from '../../api';
import { useLabelForEstimatedDeliveryPeriod } from '../../hooks/useLabel';
var ExplanationText = styled(Typography).attrs({ variant: 'caption' })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: pre-line;\n  word-break: break-word;\n"], ["\n  white-space: pre-line;\n  word-break: break-word;\n"])));
var SampleOrderConfirmationDialog = function (_a) {
    var open = _a.open, onClose = _a.onClose, role = _a.role, roaster = _a.roaster, orderedItems = _a.orderedItems, values = _a.values;
    var t = useTranslation().t;
    var navigate = useNavigate();
    var notify = useNotify();
    var createDirectSampleOrder = useRequest(sampleOrderApi.requestSamples);
    var createTypicaStockSampleOrder = useRequest(sampleOrderApi.requestTypicaStockSamples);
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(false), agree = _c[0], setAgree = _c[1];
    var labelForEstimatedDeliveryPeriod = useLabelForEstimatedDeliveryPeriod();
    var handleConfirm = React.useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var itemIds, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (orderedItems.length === 0)
                        return [2 /*return*/];
                    setLoading(true);
                    itemIds = orderedItems.map(function (item) { return item.id; });
                    request = orderedItems[0].type === 'Offer'
                        ? createDirectSampleOrder({
                            roaster_id: roaster.id,
                            sample_order: values,
                            offer_ids: itemIds,
                        })
                        : createTypicaStockSampleOrder({
                            roaster_id: roaster.id,
                            sample_order: values,
                            typica_stock_item_ids: itemIds,
                        });
                    return [4 /*yield*/, request];
                case 1:
                    response = _a.sent();
                    setLoading(false);
                    if (!response)
                        return [2 /*return*/];
                    notify('success', [t('messages.sampleOrderSuccess')]);
                    navigate(getRedirectUrl(role, response));
                    return [2 /*return*/];
            }
        });
    }); }, [
        createDirectSampleOrder,
        createTypicaStockSampleOrder,
        navigate,
        notify,
        values,
        orderedItems,
        roaster,
        t,
        role,
    ]);
    var deliveryWarningItems = React.useMemo(function () {
        return orderedItems.filter(function (orderedItem) {
            var _a;
            return orderedItem.type === 'TypicaStockItem' &&
                ((_a = orderedItem.offer.offerList.roasterTransportToWarehouse) === null || _a === void 0 ? void 0 : _a.status) !==
                    'warehousing';
        });
    }, [orderedItems]);
    return (React.createElement(Dialog, { title: t('messages.sampleOrderExplanationTitle'), open: open, onClose: onClose, actions: React.createElement(React.Fragment, null,
            React.createElement(Button, { onClick: handleConfirm, color: "primary", disabled: loading || !agree }, t('buttons.yes')),
            React.createElement(Button, { onClick: onClose, disabled: loading }, t('buttons.no'))) },
        React.createElement(ExplanationText, null, t('messages.sampleOrderExplanationBody')),
        deliveryWarningItems.length > 0 && (React.createElement(Box, { marginY: 1 },
            React.createElement(Alert, { severity: "warning" }, t('messages.deliverySampleWarningConfirmationMessage')),
            React.createElement(Table, { size: "small" },
                React.createElement(TableHead, null,
                    React.createElement(TableRow, null,
                        React.createElement(TableCell, null, t('params.offer.lotNumber')),
                        React.createElement(TableCell, null, t('pages.offerList.estimatedDeliveryPeriod')))),
                React.createElement(TableBody, null, deliveryWarningItems.map(function (item) { return (React.createElement(TableRow, { key: item.offer.id },
                    React.createElement(TableCell, null, item.offer.lotNumber),
                    React.createElement(TableCell, null, labelForEstimatedDeliveryPeriod(item.offer.offerList.roasterTransportToWarehouse)))); }))))),
        React.createElement("div", null,
            React.createElement(FormControlLabel, { control: React.createElement(Checkbox, { onChange: function (event) { return setAgree(event.target.checked); }, disabled: loading }), label: t('labels.agree') }))));
};
export default SampleOrderConfirmationDialog;
var getRedirectUrl = function (role, sampleOrders) {
    if (sampleOrders.length === 1) {
        return "/".concat(role, "/sample_orders/").concat(sampleOrders[0].id);
    }
    if (role === 'roaster') {
        return '/roaster/sample_orders';
    }
    if (sampleOrders[0].type === 'SampleOrder::DirectSampleOrder') {
        return '/admin/sample_ordered_offer_lists';
    }
    return '/admin/typica_stock_sample_orders';
};
var templateObject_1;
